export default __webpack_public_path__ + "static/media/adds.16e2754b.svg";